<template>
    <span class="underliner-wrapper">
        <span class="underliner-text" :class="{ 'underliner-active': isActive }">
            <slot></slot>
        </span>
        <svg class="underliner-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none"
            :class="{ 'underliner-active': isActive }" :style="{ bottom: svgBottom }">
            <path class="underliner-path" d="M7.7,145.6C109,125,299.9,116.2,401,121.3c42.1,2.2,87.6,11.8,87.3,25.7">
            </path>
        </svg>
    </span>
</template>

<script setup>
import { defineProps, ref, onMounted, computed, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()

const props = defineProps({
    delay: {
        type: Number,
        default: 0
    },
    bottom: {
        type: [String, Number],
        default: '-5px'
     }
})

const isActive = ref(false)
const textKey = ref(0)

const svgBottom = computed(() => {
    if (typeof props.bottom === 'number') {
        return `${props.bottom}px`
    }
    return props.bottom
})

// Animation trigger function
const triggerAnimation = async () => {
    // Reset animation state
    isActive.value = false

    // Wait for next tick to ensure DOM update    
    await nextTick()

    // Force re-render of text element
    textKey.value++

    // Start animation after delay
    setTimeout(() => {
        isActive.value = true
    }, props.delay)
}
// Watch for language changes
watch(locale, () => {
    triggerAnimation()
})

// Watch for text changes if text prop is provided
watch(() => props.text, () => {
    triggerAnimation()
})

// Initial animation
onMounted(() => {
    triggerAnimation()
})

// onMounted(() => {
//     setTimeout(() => {
//         isActive.value = true
//     }, props.delay)
//})
</script>

<style scoped>
.underliner-wrapper {
    position: relative;
    display: inline-block;
    white-space: nowrap;
}

.underliner-text {
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
}

.underliner-svg {
    position: absolute;
    left: 0;
    width: 100%;
    height: 12px;
    z-index: 1;
    opacity: 0;
    transform: scaleX(0.8);
    transition: all 0.5s ease;
}

.underliner-svg.underliner-active {
    opacity: 1;
    transform: scaleX(1);
}

.underliner-path {
    fill: none;
    stroke: #ece6e7;
    stroke-width: 60;
    stroke-linecap: round;
    stroke-dasharray: 500;
    stroke-dashoffset: 500;
    transition: stroke-dashoffset 1.2s ease;
}

.underliner-svg.underliner-active .underliner-path {
    stroke-dashoffset: 0;
}

/* Force immediate visual reset when not active */
.underliner-svg:not(.underliner-active) {
    opacity: 0;
    transform: scaleX(0.8);
    transition-duration: 0s;
}

.underliner-svg:not(.underliner-active) .underliner-path {
    stroke-dashoffset: 500;
    transition-duration: 0s;
}
</style>